import { Injectable } from '@angular/core';

export interface WorkflowEditDraft {
    name?: string;
    description?: string;
    icon?: string;
    testEmails?: string[];
    entryPoint?: string;
    allowMultipleEnrollments?: boolean;
    recordSaleCost?: boolean;
}

/**
 * Conserve en mémoire (le temps de la session, pas persisté) les champs non enregistrés du formulaire
 * "Editer le scénario" quand l'utilisateur navigue vers le canvas (édition des étapes) sans avoir
 * cliqué "Enregistrer" : ce changement de route détruit/recrée les composants, donc l'état du
 * formulaire serait perdu sans ce cache. Vidé explicitement à l'enregistrement réel ou à l'annulation
 * — jamais persisté côté serveur tant que l'utilisateur n'a pas confirmé.
 */
@Injectable({ providedIn: 'root' })
export class WorkflowEditDraftService {
    private drafts = new Map<string, WorkflowEditDraft>();

    private key(scenarioId: string, version: number): string {
        return `${scenarioId}:${version}`;
    }

    save(scenarioId: string, version: number, draft: WorkflowEditDraft): void {
        if (!scenarioId || version == null) return;
        this.drafts.set(this.key(scenarioId, version), draft);
    }

    get(scenarioId: string, version: number): WorkflowEditDraft | null {
        if (!scenarioId || version == null) return null;
        return this.drafts.get(this.key(scenarioId, version)) ?? null;
    }

    clear(scenarioId: string, version: number): void {
        if (!scenarioId || version == null) return;
        this.drafts.delete(this.key(scenarioId, version));
    }
}
